import React from "react";
import { SideBarGroupSection } from "./SideBarGroupSection";
import { SideBarMenuButton } from "./SideBarMenuButton";
import { juneTrack } from "../../../utils/june/analytics";
import { JUNE_EVENT } from "../../../hooks/june/juneEvent";
import MobaIcon from "../../atom/icons/MobaIcon";
import NewFeatureIcon from "../../atom/icons/NewFeatureIcon";
import SettingIcon from "../../atom/icons/SettingIcon";
import { pxToRem } from "../../../utils/styles/size";
import ArchivedSpacesPopover from "../../organism/Sidebar/ModalPanel/ArchivedSpacesPopover";
import CompletedTasksPopover from "../../organism/Sidebar/ModalPanel/CompletedTasksPopover";
import TrashPopover from "../../organism/Sidebar/ModalPanel/TrashPopover";

interface SideBarActionSectionProps {
  onClickSettings: () => void;
}

export const SideBarActionSection: React.FC<SideBarActionSectionProps> = ({ onClickSettings }) => {
  const handleClickFeedback = () => {
    juneTrack(JUNE_EVENT.CLICK_FEEDBACK);
    const url = "https://feedback.moba.works/";
    window.open(url, "_blank");
  };

  const handleClickNewFeature = () => {
    juneTrack(JUNE_EVENT.CLICK_UPDATE);
    const url = "https://feedback.moba.works/changelog";
    window.open(url, "_blank");
  };

  return (
    <SideBarGroupSection
      flex="0 0 auto"
      py={pxToRem(14)}
    >
      <div className="flex w-full items-center justify-between px-[2px]">
        <SideBarMenuButton
          onClick={onClickSettings}
          tooltipLabel={"Settings"}
        >
          <SettingIcon color={"#CACDCE"} />
        </SideBarMenuButton>
        <div className="hidden gap-[6px] @[220px]/sidebar:flex">
          <SideBarMenuButton
            onClick={handleClickNewFeature}
            tooltipLabel={"New Feature"}
          >
            <NewFeatureIcon color={"#CACDCE"} />
          </SideBarMenuButton>

          <SideBarMenuButton
            onClick={handleClickFeedback}
            tooltipLabel={"Product Feedback"}
          >
            <MobaIcon color={"#CACDCE"} />
          </SideBarMenuButton>
          <ArchivedSpacesPopover />
          <CompletedTasksPopover />
          <TrashPopover />
        </div>
      </div>
    </SideBarGroupSection>
  );
};
